import React from "react";
import Link from "./Link";

const BlueLink = (props) => {
  return <Link blue {...props} />;
};

export default BlueLink;
